import { render, staticRenderFns } from "./EditPhone.vue?vue&type=template&id=084d6dd2&scoped=true"
import script from "./EditPhone.vue?vue&type=script&lang=js"
export * from "./EditPhone.vue?vue&type=script&lang=js"
import style0 from "./EditPhone.vue?vue&type=style&index=0&id=084d6dd2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084d6dd2",
  null
  
)

export default component.exports